__turbopack_context__.v({
  "chatSpecialist": "BottomBar-module__yeWoaW__chatSpecialist",
  "ctaStack": "BottomBar-module__yeWoaW__ctaStack",
  "midPanel": "BottomBar-module__yeWoaW__midPanel",
  "midPanelPhone": "BottomBar-module__yeWoaW__midPanelPhone",
  "midPanelPhonePrice": "BottomBar-module__yeWoaW__midPanelPhonePrice",
  "midPanelPhoneRight": "BottomBar-module__yeWoaW__midPanelPhoneRight",
  "midPanelPhoneRow": "BottomBar-module__yeWoaW__midPanelPhoneRow",
  "offerIcon": "BottomBar-module__yeWoaW__offerIcon",
  "offerIcons": "BottomBar-module__yeWoaW__offerIcons",
  "root": "BottomBar-module__yeWoaW__root",
  "subtitleTextBtn": "BottomBar-module__yeWoaW__subtitleTextBtn",
  "taxDisclaimer": "BottomBar-module__yeWoaW__taxDisclaimer",
  "totalPriceSingle": "BottomBar-module__yeWoaW__totalPriceSingle",
  "tradeInCredit": "BottomBar-module__yeWoaW__tradeInCredit",
});
